import { Box, Grid, useTheme } from "@mui/material";
import { TourProvider } from "@reactour/tour";
import { INCOMLEND_INTERNAL, NEW_USER } from "codes";
import DashboardHeader from "components/Dashboard/DashboardHeader";
import auth from "helpers/auth";
import { roleRedirect } from "helpers/redirect";
import { DASHBOARD_STEPS } from "helpers/tourSteps";
import { useEffect } from "react";
import { useAppSelector } from "redux/hooks";

const DashboardPage = () => {
  auth();
  const theme = useTheme();
  const APP_STATE = useAppSelector((state) => state.appState.value);
  const APP_PERMISSION = useAppSelector((state) => state.appState.permission);

  useEffect(() => {
    if (APP_PERMISSION === INCOMLEND_INTERNAL) {
      roleRedirect(INCOMLEND_INTERNAL);
    }
  }, [APP_PERMISSION]);

  return (
    <Box
      id="dashboard-landing-box"
      margin="auto"
      sx={{ backgroundColor: theme.palette.background.paper }}
    >
      <TourProvider steps={DASHBOARD_STEPS[APP_STATE]}>
        {APP_STATE !== NEW_USER && (
          <Grid container spacing={3}>
            <DashboardHeader />
          </Grid>
        )}
      </TourProvider>
    </Box>
  );
};

export default DashboardPage;
